import { render, staticRenderFns } from "./TaskUserSelector.vue?vue&type=template&id=ba973434&"
import script from "./TaskUserSelector.vue?vue&type=script&lang=js&"
export * from "./TaskUserSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaskUserSelector.vue?vue&type=style&index=0&id=ba973434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports